import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { Integration } from '@futrli-sdk/app-store';
import { Organisation } from '@futrli-sdk/organisations';
import { OrganisationListItem, WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { OrganisationUploadDrawerInner } from './organisation-upload-drawer-inner';

interface Props {
  title?: ReactElement | string;
  children: JSX.Element;
  isOpen?: boolean;
  handleClose: () => void;
  maxFileSize?: number; // in MB
  acceptedFileExtensions?: string;
  workspaceId: string;
  excelIntegration: Integration | undefined;
  isUpdateDrawer?: boolean;
  isOnboarding?: boolean;
  workspaceByBusinessId?: WorkspacesListingItem;
  organisationByBusinessId?: OrganisationListItem;
  businessId?: string | null;
  organisation?: Organisation;
  disableCreate?: boolean;
  countryCode?: string;
}

export const OrganisationUploadDrawer = ({
  title = <FormattedMessage id="common.upload_file" defaultMessage="Upload a file" />,
  isOpen,
  children,
  ...rest
}: Props) => {
  return (
    <Sidebar
      open={!!isOpen}
      header={
        <Typography variant="h2" fontWeight="700" id="excel-upload-drawer-form-title">
          {title}
        </Typography>
      }
      aria-labelledby="excel-upload-drawer-form-title"
    >
      <OrganisationUploadDrawerInner {...rest}>{children}</OrganisationUploadDrawerInner>
    </Sidebar>
  );
};
